import axios from 'axios';

import { REQUEST_REASON } from 'RestAPIs/endpoints';

export interface RequestListValue {
  id: number;
  name: string;
  code: string;
  auxValueId?: number | null;
  groupId?: number | null;
  flags?: string[] | null;
}

export const getRequestReasonValues = () => {
  return axios.get<RequestListValue[]>(`${REQUEST_REASON}`);
};
